module.exports = "https://cdn.dove.it/_next/static/public/assets/powered-by-google.46afd78d537c22b564e7baad76bac26a.png";